import { render, staticRenderFns } from "./CUpload.vue?vue&type=template&id=565a4dd1&scoped=true"
import script from "./CUpload.vue?vue&type=script&lang=js"
export * from "./CUpload.vue?vue&type=script&lang=js"
import style0 from "./CUpload.vue?vue&type=style&index=0&id=565a4dd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a4dd1",
  null
  
)

export default component.exports